import PActions from "../../Stores/redux/Persist/Actions";
import UnpActions from "../../Stores/redux/UnPersist/Actions";

import api from "../../Services/Api/api";
import { getStore } from "../../Providers/store";

export const sendLogoutSignal = () => {
  const store = getStore();
  if (store) {
    let headers = {};
    let token = store.getState()?.pState?.user?.token;
    if (token) {
      headers = { ...headers, authorization: "Bearer " + token };
      api
        .post("v1/user/logout", {}, { noRedirect: true, headers })
        .catch(console.info);
    }
  }
};

export const logout = async () => {
  // let socket = getSocket();
  // socket && socket.disconnect();
  // setSocket(null);

  const store = getStore();
  if (store) {
    sendLogoutSignal();

    store.dispatch(
      // PActions.setPScreenState("user", {
      //   user: null,
      //   token: null,
      //   impersonator: null,
      // })

      PActions.resetPState()
    );
     store.dispatch(UnpActions.resetVState());
  }

  return null;
};
